import { createFileRoute } from '@tanstack/react-router'
import { ReportsAddPage } from '@/features/reports/components/ReportsAddPage'

export const Route = createFileRoute('/_auth/reports/add')({
  component: ReportsAddRoute,
})

function ReportsAddRoute() {
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-2xl font-bold mb-6 uppercase tracking-wide">
        Reports - Add
      </h1>
      <ReportsAddPage />
    </div>
  )
}
